import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DashboardFichaComponent} from "./dashboard-ficha/dashboard-ficha.component";
import {GraficasModule} from "../graficas/graficas.module";

@NgModule({
    imports:[
        CommonModule,
        GraficasModule
    ],
    declarations: [
        DashboardFichaComponent
    ],
    exports: [
        DashboardFichaComponent
    ],
    providers: []
})

export class DashboardModule {}